import React from 'react'
import {
  BaseEntityInterface,
  BaseEntityWithChildIdsInterface,
  EntityInnerItemInterface,
} from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { useOnLoadVisibility } from 'publisher/hooks/use-onload-visibility'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'

export const OnloadPopups = () => {
  const desktopOnloadPopups = usePage(pageSelectors.getOnloadPopups)
  // mobile onload it is a "mobile on exit" option actually
  const mobileOnloadPopups = usePage(pageSelectors.getMobileOnloadPopups)
  const pageId = usePage(pageSelectors.getPageId)
  const isMobile = useManagement(managementSelectors.isMobile)

  const renderedDesktopOnLoadPopups = desktopOnloadPopups.map(popup => (
    <OnloadPopup pageId={pageId} key={popup.id} popup={popup} />
  ))

  if (typeof window !== 'undefined' && isMobile) {
    return mobileOnloadPopups
      .map(popup => (
        <MobileOnloadPopup pageId={pageId} key={popup.id} popup={popup} />
      ))
      .concat(renderedDesktopOnLoadPopups)
  } else {
    return renderedDesktopOnLoadPopups
  }
}

interface OnloadPopupProps {
  popup:
    | OldEntityInterface
    | BaseEntityInterface
    | EntityInnerItemInterface
    | BaseEntityWithChildIdsInterface
  pageId: number
}

export function OnloadPopup({ popup, pageId }: OnloadPopupProps) {
  useOnLoadVisibility(
    pageId,
    popup.id,
    (popup as PopupInterface)?.delay ||
      (popup as OldEntityInterface)?.options?.delay,
  )

  return null
}

interface MobileOnloadPopupProps {
  popup:
    | OldEntityInterface
    | BaseEntityInterface
    | EntityInnerItemInterface
    | BaseEntityWithChildIdsInterface
  pageId: number
}

export function MobileOnloadPopup({ popup, pageId }: MobileOnloadPopupProps) {
  useOnLoadVisibility(
    pageId,
    popup.id,
    (popup as PopupInterface)?.mobileDelay ||
      (popup as OldEntityInterface)?.options?.mobileDelay,
  )

  return null
}
